import React from "react";

import SvgUsersX from "@uui/UsersX";

import { Typography, styled } from "@mui/material";

import IconBackground from "@rui/IconBackground";
import Stack, { Row } from "@rui/Stack";

const Card = styled(Row)(({ theme }) => ({
  borderRadius: "8px",
  border: `solid 1px ${theme.palette.shades.neutral[100]}`,
  padding: theme.spacing(1.5),
  color: theme.palette.shades.neutral[600],
  boxShadow: "0px 1px 16px 0px rgba(35, 31, 56, 0.04)",
}));

const InternalAccessUnavailable = ({ userDomain }: { userDomain: string }) => {
  return (
    <Card spacing={1}>
      <IconBackground
        sx={{ bgcolor: "shades.primary.50", color: "shades.primary.500" }}
        borderRadius={8}
        height={28}
      >
        <SvgUsersX />
      </IconBackground>
      <Stack>
        <Typography variant="bodySecondaryMed">
          Internal access not available
        </Typography>
        <Typography variant="bodySecondaryReg">
          The domain associated with your Read account{" "}
          {userDomain ? `(@${userDomain})` : ""} is generic, so all participants
          are considered external. Use the external participant access setting
          below to control report access.
        </Typography>
      </Stack>
    </Card>
  );
};

export default InternalAccessUnavailable;
